var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.4,0C60.3,0,70.1,0,80,0c11.8,0.1,19.9,8.1,20,19.8c0.1,20.1,0.1,40.2,0,60.3c0,11.5-8.1,19.7-19.6,19.8 c-20.2,0.1-40.5,0.1-60.7,0C8.2,99.9,0.1,91.7,0,80.1C0,60,0,39.9,0,19.8C0.1,8.1,8.2,0.1,20,0C30.2,0,40.3,0,50.4,0z M50,93.3 c10,0,20,0,30,0c8.1,0,13.3-5.2,13.3-13.2c0.1-20,0.1-39.9,0-59.9c0-8.3-5.2-13.4-13.5-13.4c-19.8,0-39.7,0-59.5,0 c-8.4,0-13.5,5.1-13.5,13.4c0,19.8,0,39.7,0,59.5c0,8.6,5.1,13.6,13.8,13.7C30.3,93.3,40.2,93.3,50,93.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7,70.6c0-3.2-0.3-6.6,0.1-10c0.2-1.6,1.9-4,3.2-4.2c2.5-0.5,3.4,1.7,3.3,4.1c0,6.4-0.1,12.8,0,19.1 c0,2.7-1.2,3.7-3.8,3.6c-6.4-0.1-12.8-0.1-19.1,0c-2.5,0-4.5-1-4-3.5c0.3-1.3,2.4-2.9,3.9-3.1c3.5-0.4,7.1-0.1,10.3-0.1 C54.8,60.8,39.2,45.1,23.3,29.2c0,3.5,0.3,7.1-0.1,10.5c-0.2,1.4-2,2.7-3.1,4c-1.1-1.3-3.2-2.5-3.3-3.8c-0.3-6.6-0.3-13.3,0-20 c0.1-1.1,2-3.1,3.1-3.1c6.6-0.3,13.3-0.3,20,0c1.3,0.1,2.5,2.1,3.8,3.3c-1.3,1.1-2.6,2.9-4,3.1c-3.5,0.5-7.1,0.1-10.4,0.1 C45.2,39.1,60.9,54.8,76.7,70.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/size.ab936655.svg";
export { ForwardRef as ReactComponent };